import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { TextField } from "@mui/material";
import { useConfirmedAddSubmit } from "../shared/useConfirmedAddSubmit";
import ConfirmAddDialog from "../util/confirmAddDialog";
import AddFormLayout from "../shared/AddFormLayout";
import SectionGrid from "../shared/SectionGrid";
import { useSectionedForm } from "../shared/useSectionedForm";

const FORM_SECTIONS = [
  {
    id: "details",
    label: "Config details",
    fields: ["ServiceName", "PropertyName", "PropertyValue"],
  },
];

const ServiceConfigForm = () => {
  const validationSchema = Yup.object().shape({
    ServiceName: Yup.string().required("Service Name is required"),
    PropertyName: Yup.string().required("Property NAme is required"),
    PropertyValue: Yup.string().required("Property Value is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { sections, activeId, setActiveId } = useSectionedForm(
    FORM_SECTIONS,
    errors
  );

  const navigate = useNavigate();

  const { onSubmit, confirmDialogProps } = useConfirmedAddSubmit({
    resourcePath: "integrations/cfg/serviceconfigs",
    notificationTitle: "Service Config",
    navigate,
    navigateTo: "/ServiceConfigs",
  });

  return (
    <>
      <AddFormLayout
        title="Add service config"
        sections={sections}
        activeSectionId={activeId}
        onSectionChange={setActiveId}
        onBack={() => navigate(-1)}
        primaryLabel="Add"
        onPrimaryClick={handleSubmit(onSubmit)}
      >
        <SectionGrid>
          <TextField
            required
            label="Service Name"
            size="small"
            fullWidth
            {...register("ServiceName")}
            error={!!errors.ServiceName}
            variant="outlined"
          />
          <TextField
            required
            label="Property Name"
            size="small"
            fullWidth
            {...register("PropertyName")}
            error={!!errors.PropertyName}
            variant="outlined"
          />
          <TextField
            required
            label="Property Value"
            size="small"
            fullWidth
            {...register("PropertyValue")}
            error={!!errors.PropertyValue}
            variant="outlined"
          />
        </SectionGrid>
      </AddFormLayout>

      <ConfirmAddDialog {...confirmDialogProps} itemLabel="service config" />
    </>
  );
};

export default ServiceConfigForm;
